module.exports = __webpack_public_path__ + "45ac4d0b4ffa9c6ea0dbdcd48462fbeb.svg";